
export class AvatarConfig {

	avatarsConfigPath = null;

	_avatars = null;

	constructor(avatarsConfigPath = '/static/avatars/index.json') {
		this.avatarsConfigPath = avatarsConfigPath;
	}

	async getAvatarsInfo() {
		return $.ajax({
			url: this.avatarsConfigPath,
			contentType: 'application/json',
			headers: {
				'Accept': 'text/json'
			}
		});
	}

	async getAvatars() {
		if (!this._avatars) {
			this._avatars = await this.getAvatarsInfo();
		}

		return this._avatars;
	}
}
